<template>
  <div class="quarter-content">
    <h1>{{ content.number }}</h1>
    <h2>{{ content.topic }}</h2>
    <p>{{ content.txt }}</p>
  </div>
</template>

<script>
export default {
  props: {
    quaterContent: {
      type: Object,
      default: () => ({
        number: '01.',
        topic: '監測',
        txt:
          '田間氣象監測，是給予農民安心的保證。我們期許成為田間的守護者，幫忙像擔心孩子受餓著冷父母般的農民，透過氣象數據蒐集，將科學術語轉換成親切問候，在日常中提醒您在田間的作物生長環境變化，就像稻草人，靜靜地在農田中做好守護者的角色。',
      }),
    },
  },
  data() {
    return {
      content: this.quaterContent,
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.quarter-content {
  position: relative;
  padding: 30px;
  margin: 30px 0;
  text-align: justify;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-radius: 10px;
  h1 {
    width: 100%;
    color: #ddd;
    font-size: 6rem;
    position: absolute;
    top: -35px;
    left: 0;
    opacity: 0.5;
    z-index: -1;
  }
  h2 {
    font-size: 1.5rem;
    margin-bottom: 20px;
  }
  p {
    font-size: 1.2rem;
    color: #8f8f8f;
    font-weight: 300;
  }
}
</style>
